import React from "react";

const MenuIcon = (props) => {
  return (
    <svg
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.94831 6H20.0513C20.5733 6 21.0003 6.427 21.0003 6.949V7.051C21.0003 7.573 20.5733 8 20.0513 8H3.94831C3.42631 8 3.00031 7.573 3.00031 7.051V6.949C3.00031 6.427 3.42631 6 3.94831 6ZM20.0513 11H3.94831C3.42631 11 3.00031 11.427 3.00031 11.949V12.051C3.00031 12.573 3.42631 13 3.94831 13H20.0513C20.5733 13 21.0003 12.573 21.0003 12.051V11.949C21.0003 11.427 20.5733 11 20.0513 11ZM20.0513 16H3.94831C3.42631 16 3.00031 16.427 3.00031 16.949V17.051C3.00031 17.573 3.42631 18 3.94831 18H20.0513C20.5733 18 21.0003 17.573 21.0003 17.051V16.949C21.0003 16.427 20.5733 16 20.0513 16Z"
        fill="currentColor"
      />
      <mask
        id="mask"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="6"
        width="19"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.94831 6H20.0513C20.5733 6 21.0003 6.427 21.0003 6.949V7.051C21.0003 7.573 20.5733 8 20.0513 8H3.94831C3.42631 8 3.00031 7.573 3.00031 7.051V6.949C3.00031 6.427 3.42631 6 3.94831 6ZM20.0513 11H3.94831C3.42631 11 3.00031 11.427 3.00031 11.949V12.051C3.00031 12.573 3.42631 13 3.94831 13H20.0513C20.5733 13 21.0003 12.573 21.0003 12.051V11.949C21.0003 11.427 20.5733 11 20.0513 11ZM20.0513 16H3.94831C3.42631 16 3.00031 16.427 3.00031 16.949V17.051C3.00031 17.573 3.42631 18 3.94831 18H20.0513C20.5733 18 21.0003 17.573 21.0003 17.051V16.949C21.0003 16.427 20.5733 16 20.0513 16Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask)">
        <rect width="24" height="24" />
      </g>
    </svg>
  );
};

export default MenuIcon;
